const config = require('../config'); const apiConfig = require('../api-config');
const serviceFactory = require('../resources/payment-initiation-service/service-factory');
const apiFactory = require('../resources/payment-initiation-service/api-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/psd2pisservice/${apiConfig.apiversion}/`
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';
  return app => app
    .match(`${p}pis.paymentDetails[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
      service.paymentDetails(req.params)
        .then(response => res.value(response))
        .catch(res.error)
      
    )))

    .match(`${p}pis.consentUpdate[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
      service.consentUpdate(req.params)
        .then(response => res.value(response))
        .catch(res.error)
    )
  ))

  .match(`${p}pis.confirmedPayment[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
    requests.map(({ req, res }) =>
    service.confirmedPayment(req.params)
      .then(response => res.value(response))
      .catch(res.error)
  )
))
  
   .match(`${p}pis.updatePayment[{keys:inputParam}][{keys:guidStr}]`,requests=>Promise.all(
    requests.map(({req,res})=>
    service.updatePayment(req.params)
    .then(response=>{
      return res.value(response)
    })
    .catch(res.error)
    )
))
}

module.exports = addRoutes;

